import React, { useState, useContext } from "react";
import { CardHeader, CardContent, CardFooter } from "@/components/ui/card";
import { SetTone, SetFrequency } from "./steps";
import { SetTopic } from "./SetTopic";
import { Header, Footer } from "./headerAndFooter";
import { NewsletterContext } from "../context/NewsletterContext";
import { SetupComplete } from "./SetupComplete";
interface NewsletterData {
  topics: string[];
  tone: string;
  frequency: string;
  preferred_day: string;
  tester_email: string;
}

export const NewsletterForm: React.FC<{
  newsletterData?: NewsletterData;
}> = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const { config } = useContext(NewsletterContext);

  const canProceedToNextStep = (): boolean => {
    switch (currentStep) {
      case 1:
        return config.topics.length > 0;
      case 2:
        return !!config.tone;
      case 3:
        return (
          !!config.frequency &&
          (config.frequency === "daily" ||
            (config.frequency === "weekly" && !!config.preferredDay))
        );
      case 4:
        return true;
      default:
        return false;
    }
  };

  const renderStep = (currentStep: number) => {
    switch (currentStep) {
      case 1:
        return <SetTopic />;
      case 2:
        return <SetTone />;
      case 3:
        return <SetFrequency />;
      case 4:
        return <SetupComplete />;
      default:
        return null;
    }
  };

  return (
    <div className="max-w-4xl mx-auto">
      <CardHeader>
        <Header currentStep={currentStep} />
      </CardHeader>
      <CardContent>{renderStep(currentStep)}</CardContent>
      <CardFooter>
        <Footer
          currentStep={currentStep}
          setCurrentStep={setCurrentStep}
          canProceed={canProceedToNextStep()}
        />
      </CardFooter>
    </div>
  );
};
